import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { EmployeeDocumentsFolderListPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import DocumentURLContext from 'modules/documents/components/Documents/List/DocumentURLContext'
import FolderType from 'modules/documents/components/FolderType'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const FoldersPage = () => {
  const { navigation } = useNavigation()
  const { id, folderId: folderIdParam } = useParams()
  const employeeId = Number(id)
  const folderId = Number(folderIdParam)
  const [selectedFolder, setSelectedFolder] = useState<Folder | null>()

  const { loading, data, error } = useQuery(EmployeeDocumentsFolderListPageDocument, {
    variables: {
      employeeId: employeeId,
      folderId: Number(folderId),
    },
  })

  const folderOwner = data?.employees?.employee
  const employeeFolder = folderOwner?.folders.find((f) => f.folderId === Number(folderId))
  const folder = data?.documents?.folders[0]

  useUnsafeEffect(() => {
    setSelectedFolder(folder)
  }, [folder])

  const canUploadDocument = (employeeFolder && employeeFolder._policies?.edit.can) ?? false

  const authorized = employeeFolder !== undefined && folder !== undefined

  if (loading)
    return (
      <Box width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  if (!folder) return <NotFound />

  const documentRoutesContext = {
    show: (documentId: string | number) =>
      navigation.employees.id.documents.folderId.documentId.fullPath({
        id: employeeId,
        document_id: Number(documentId),
        folderId,
      }),
  }

  const newDocumentUrl = navigation.employees.id.documents.folderId.new.fullPath({
    id: employeeId,
    folderId: Number(folderId),
  })

  return (
    <DocumentURLContext.Provider value={documentRoutesContext}>
      <ResponsivePage.Body
        loading={loading}
        error={error}
        showHeader={false}
        authorized={authorized}
      >
        {folder && (
          <FolderType
            folder={folder}
            employeeId={employeeId}
            legalEntityCountry={data?.employees?.employee?.legalEntity?.country}
            parentRoute={navigation.employees.id.documents.folderId.fullPath({
              id: employeeId,
              folderId,
            })}
            backActionUrl={newDocumentUrl}
            selectedFolder={selectedFolder}
            onFolderSelected={setSelectedFolder}
            canUploadDocument={canUploadDocument}
            isLoading={loading}
          />
        )}
      </ResponsivePage.Body>
    </DocumentURLContext.Provider>
  )
}

export default observer(FoldersPage)
